import { forwardRef } from "react";

import { formatAriaInvalid } from "./style.utils";
import { textInputVariants, type TextInputVariants } from "./text-input.styles";

export type TextInputRef = React.ComponentRef<"input">;

export interface TextInputProps
  extends
    Omit<React.ComponentPropsWithoutRef<"input">, "size" | "type">,
    Omit<TextInputVariants, "invalid"> {
  type?: "text" | "email";
  name: string;
}

const TextInput = forwardRef<TextInputRef, TextInputProps>(
  (
    { "aria-invalid": ariaInvalid, className, disabled, size, type, ...props },
    ref,
  ) => {
    return (
      <input
        {...props}
        type={type ?? "text"}
        disabled={disabled}
        aria-invalid={ariaInvalid}
        className={textInputVariants({
          className,
          disabled,
          invalid: formatAriaInvalid(ariaInvalid),
          size,
        })}
        ref={ref}
      />
    );
  },
);

TextInput.displayName = "TextInput";

export { TextInput };
